import { RootState } from '../../';
import { createSelector } from '@reduxjs/toolkit';

export const selectAdminState = (state: RootState) => state.admin;

export const selectAdminLoading = createSelector(selectAdminState, (admin) => admin.isLoading);
